import { useTranslation } from 'react-i18next';

const serviceIcons = [
  'ri-file-list-3-line',
  'ri-building-line',
  'ri-file-edit-line',
  'ri-bank-card-line',
  'ri-passport-line',
  'ri-customer-service-2-line',
];

export default function Services() {
  const { t } = useTranslation('common');
  
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {serviceIcons.map((icon, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mb-6">
                <i className={`${icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t(`services.items.${index}.title`)}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t(`services.items.${index}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
